<template>
<div class="container-fluid pt-4">
	<widget>
		<div class="header">
			<div class="overlay"></div>
			<div class="header-content-container">
				<div v-if="type == 'user'" class="d-flex flex-row justify-content-between flex-wrap">
					<router-link v-if="!$store.userDetails" to="/contacts" class="text-white">
						<i class="fa fa-arrow-left"></i> Back to Contacts Network
					</router-link>
					<div class="d-flex justify-content-end w-100">
						<template v-if="$store.userDetails && $store.sessionToken">
							<div>
								<button class="btn btn-info mr-2" v-on:click="messageUser">
									<i class="fa fa-envelope mr-1"></i>
									Message
								</button>
							</div>
							<div v-if="hasModulePermWrite('Users') && !userIsCoworker && userMyCompany && !userMyCompany.invite_accepted && userMyCompany.invite_declined == 0">
								<button class="btn btn-info mr-2" v-on:click="offerEmployment(record)">
									<i class="fa fa-mail-forward mr-1"></i>
									Offer pending: Send again
								</button>
							</div>
							<div v-else-if="hasModulePermWrite('Users') && !userIsCoworker" class="ml-1">
								<button class="btn btn-primary mr-2" v-on:click="offerEmployment">
									<i class="fa fa-handshake mr-1"></i>
									Offer Employment
								</button>
							</div>
							<div v-if="!contactMatchIsLinked">
								<button class="btn btn-info mr-2" v-on:click="addAsContact">
									<i class="fa fa-address-book mr-1"></i>
									Add to Contacts
								</button>
							</div>
						</template>

						<!--
						<button class="btn btn-info" v-on:click="downloadUserContact(record)">
							<i class="fa fa-download mr-1"></i>
							Download Contact
						</button>
						-->
					</div>
				</div>
				<div v-if="type == 'company'" class="d-flex flex-row justify-content-between flex-wrap">
					<router-link to="/contacts" class="text-white">
						<i class="fa fa-arrow-left"></i> Back to Contacts Network
					</router-link>
					<div class="d-flex flex-row ">
						<div v-if="!contactMatchIsLinked">
							<button class="btn btn-info" v-on:click="addAsContact">
								<i class="fa fa-address-book"></i>
								Add as a Contact
							</button>
						</div>
					</div>
				</div>
				<div class="header-content">
					<image-panel v-if="profileImageSrc"
						class='profile-image-panel' 
						:readonly="true" 
						:image-url="profileImageSrc"
						:expand-on-click="true">		
					</image-panel>

					<widget v-else class='profile-image-panel'>
						<div class="d-flex flex-row align-items-center justify-content-center" style="width: 220px;height: 200px;">
							<i class="fa fa-user fa-fw fa-5x mb-2"></i>
						</div>
					</widget>

					<div class="heading-container">
						<h1>{{ profileTitle }}</h1>
						<h2 v-if="profileSubTitle">{{ profileSubTitle }}</h2>
					</div>
				</div>
			</div>
		</div>

		<div class="profile-main">
			<div v-if="type == 'user'" class="profile-main-content">
				<p v-if="contactMatchIsLinked">
					<router-link :to="'/contact/'+record.ContactLink.slug+'/details'">View Contact Entry</router-link>
				</p>

				<h3 v-if="record.job_title">{{ record.job_title }}</h3>
				<h3 v-else-if="record.description">Description</h3>
				<p v-if="record.description">{{ record.description }}</p>

				<div class="d-flex flex-column mb-4">
					<a v-if="record.email" :href="'mailto:'+record.email">{{ record.email }}</a>
					<a v-if="record.phone" :href="'tel:'+record.phone">{{ record.phone }}</a>
				</div>

			</div>
			<div v-else-if="type == 'company'" class="profile-main-content">
				<p v-if="contactMatchIsLinked">
					<router-link :to="'/contact/'+record.ContactLink.slug+'/details'">View Contact Entry</router-link>
				</p>

				<div class="d-flex flex-column mb-4">
					<a v-if="record.email" :href="'mailto:'+record.email">{{ record.email }}</a>
					<a v-if="record.phone" :href="'tel:'+record.phone">{{ record.phone }}</a>
					<a v-if="record.website" :href="'//'+record.website">{{ record.website }}</a>
				</div>

				<template v-if="record.description">
					<h3>About</h3>
					<p>{{ record.description }}</p>
				</template>

				<template v-if="record.address">
					<h3>Head Office</h3>

					<p>
						<address>
							{{ record.address }}<br>
							{{ record.city }}, {{ record.province }}, {{ record.country }}<br>
							{{ record.postal_code }}
						</address>
					</p>
				</template>

			</div>
		</div>
	</widget>
</div>
</template>
<script type="text/javascript">
import ImagePanel from "@/components/ImagePanel"
import Widget from "@/components/Widget"

export default {
	components: {
		Widget,
		ImagePanel
	},
	data() {
		return {
			record: {}
		}
	},
	computed: {
		type() {
			return this.$route.params.type
		},
		profileTitle() {
			if (this.type == "user") {
				return this.record.first_name+" "+this.record.last_name
			}
			else if (this.type == "company") {
				return this.record.company_name
			}
		},
		profileSubTitle() {
			if (this.type == "user") {
				if ("EmployeeClassification" in this.record && this.record.EmployeeClassification && this.record.EmployeeClassification.length > 0)
					return this.record.EmployeeClassification[0].title
			}
			else if (this.type == "company") {
				if ("BusinessType" in this.record)
					return this.record.BusinessType.map(type => type.type).join(", ")
			}
		},
		profileImageSrc() {
			if ("ProfileImage" in this.record && this.record.ProfileImage)
				return window.apiRoot+"resources/profile-images/"+this.record.ProfileImage.slug+"/"+this.record.ProfileImage.filename
			else
				return false
		},
		unionMembership() {
			if (this.record && "Union" in this.record && this.record.Union)
				return this.record.Union.union_name

			return false
		},
		userIsCoworker() {
			return "CompanyUser" in this.record && this.record.CompanyUser && this.userMyCompany && this.userMyCompany.invite_declined == 0 && this.userMyCompany.is_inactive == 0 && this.userMyCompany.invite_accepted
		},
		userMyCompany() {
			if ("CompanyUser" in this.record && this.record.CompanyUser) {
				return this.record.CompanyUser.find(company => company.tenant_id == this.$store.userDetails.tenant_id)
			}
			return false
		},
		contactMatchIsLinked() {
			if ("ContactLink" in this.record && this.record.ContactLink && this.record.ContactLink.link_accepted == 1)
				return true
			else
				return false
		}
	},
	methods: {
		offerEmployment() {
			let vm = this

			vm.postData("CompanyUser/offer-employment",{user_id:this.record.id},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Connection invite sent!")
					vm.fetchRecord()
				}
			})
		},
		messageUser() {
			let vm = this

			this.$bus.$emit("newThread",false,false,[this.record],[this.record.id])
		},
		addAsContact() {
			let vm = this

			let payload = {
				link_accepted: 1,
				link_denied: 0
			}
			if (this.record.ContactLink) 
				payload.id = this.record.ContactLink.id
			else {
				if (this.type == "user") {
					payload.name = this.record.first_name+" "+this.record.last_name
					payload.email = this.record.email
				}
				else if (this.type == "company")
					payload.name = this.record.company_name
			}

			this.postData("Contact/save",payload).then(response => {
				if (response.success) {
					vm.alertSuccess("This "+vm.type+" has been added to your network as a contact!")

					if ("ContactLink" in vm.record && vm.record.ContactLink) {
						vm.record.ContactLink.link_accepted = 1
						vm.record.ContactLink.link_denied = 0
					}
					else {
						//just mock the object out so it passes the "contactMatchisLinked" test
						vm.record.ContactLink = {
							link_accepted: 1,
							id: response.data.record_id
						}
					}
					
				}
			})	
		},
		fetchRecord() {
			let vm = this

			let params = {
				include: ["ProfileImage","Contact"]
			}

			let endpoint = ""
			if (this.type == "company") {
				endpoint = "Company"
				params.include.push("BusinessType")
			}
			else {
				endpoint = "User"
				params.include.push("EmployeeClassification")
				params.include.push("CompanyUser")
				params.include.push({
					model: 'Company',
					include: ["ProfileImage"]
				})
			}

			this.getJSON(endpoint+"/find/"+this.$route.params.slug,params).then(response => {
				if (response.success)
					this.record = response.data
			})
		},

	},
	created() {
		this.fetchRecord()
	}
}
</script>

<style type="text/css" scoped>
	.container-fluid {
		max-width: 1200px;
		margin: auto;
		padding-top: 0;
		margin-top: -16px!important;
	}

	.header {
		background-image: url("/resources/abstract_yellow.jpg");
		background-size: cover;
		background-repeat: no-repeat;
		margin: -8px;
		margin-top: -18px;
		margin-bottom: -17px;
		border-radius: 5px;
		position: relative;
	}

	.header .overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.7);
		z-index: 1;
	}

	.header-content-container {
		position: relative;
		z-index: 2;
		padding: 10px;
	}

	.header .controls {
		position: relative;
		justify-content: flex-end;
		display: flex;
		flex-direction: row;
		padding: 10px;
	}

	.header .controls > * {
		margin-left: 5px;
	}

	.profile-image-panel {
		max-width: 300px;
		position: relative;
		margin-top: 10px;
		margin-left: 30px;
		margin-bottom: -40px;
	}

	.header-content {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		position: relative;
	}

	.heading-container {
		margin-left: 50px;
	}

	.header-content h1, 
	.header-content h2 {
		color: white;
	}

	.profile-main {
		margin-top: 50px;
	}

	.profile-main-content {
		margin-left: 370px;
	}

	@media (max-width: 800px) {
		.header-content {
			flex-direction: column;
		}

		.profile-image-panel {
			position: relative;
			display: block;
			margin: auto;
			top: auto;
			margin-top: 70px;
		}

		.heading-container {
			margin: 20px;
			width: calc(100% - 40px);
			text-align: center;
		}

		.profile-main-content {
			margin: 20px;
		}
	}
</style>